import React from "react";

const Card = ({title, isVisible, image, bg_color, title_color, hover_color, index, index_color, description_top_color, description_bot_color, description_top_xs, description_bot_xs, description_top_mobile, description_bot_mobile }) => {
    return(
        <div style={{backgroundColor:`${bg_color}`}} className={`xs:p-6 p-3 w-[100%] xs:h-[133px] h-[140px] bg-[${bg_color}] rounded-2xl overflow-hidden relative group flex flex-row items-center`}>
            <div className="xs:block hidden w-full h-full">
              <div className="w-full h-full  group flex flex-row items-center">
                <div>
                <h1 
                        style={{
                          color: isVisible ? `${hover_color}` : `${title_color}`,
                          transition: "opacity 0.5s ease",
                        }} className={`lg:text-[28px] xs:text-[24px] text-[24px]  z-10 relative`}>{title}</h1>
                </div>
                <span style={{
                          color: isVisible ? `${hover_color}` : `${index_color}`,
                          transition: "opacity 0.5s ease",
                        }}
                        className="ml-auto mb-auto z-10">{index}</span>
                <div 
                    style={{
                      backgroundImage: `url(${image})`,
                      opacity: isVisible ? 1 : 0,
                      transition: "opacity 0.5s ease",
                    }} className=" absolute inset-0 bg-center bg-cover"></div>
              </div>           
            </div>
            <div className="xs:hidden block w-full h-full">
              <div className="flex flex-row">
                  <span style={{color: `${description_top_color}`}} className={`text-[18px] lg:text-[20px] lg:hidden block`}>
                      {description_top_mobile}
                  </span>
                  <span style={{
                          color: `${index_color}`,
                          transition: "opacity 0.5s ease",
                        }}
                        className="ml-auto mb-auto z-10 text-[12px]">{index}</span>
              </div>
              <div className="mt-2">
                  <span style={{color: `${description_bot_color}`}} className={`text-[14px] lg:text-[14px] lg:hidden block`}>
                      {description_bot_mobile}
                  </span>
              
              </div>
            </div>
        </div>
    );
};

export default Card;